import { useState } from "react";
import KaspiModal from "../kaspiModal";
import kaspiLogo from "../../assets/images/kaspi/kaspi.svg";
import kaspiGold from "../../assets/images/kaspi/kaspi-gold.svg";
import kaspiRed from "../../assets/images/kaspi/kaspi-red.svg";
import styles from "./styles.module.scss";

const CartKaspiButton = ({ orderNumber, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        disabled={isOpen}
        className={styles.kaspi}
        aria-label="Оплатить через Kaspi"
      >
        <span className={styles.kaspiContent}>
          <img
            src={kaspiLogo}
            alt="Kaspi"
            width="120"
            height="40"
            className={styles.kaspiLogo}
          />
          <span className={styles.kaspiDivider} />
          <span className={styles.kaspiMethods}>
            <img
              src={kaspiGold}
              alt="Kaspi Gold"
              width="20"
              height="20"
              className={styles.kaspiMethodIcon}
            />
            <img
              src={kaspiRed}
              alt="Kaspi Red"
              width="20"
              height="20"
              className={styles.kaspiMethodIcon}
            />
          </span>
        </span>
      </button>
      <KaspiModal
        orderNumber={orderNumber}
        show={isOpen}
        onClose={() => setIsOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default CartKaspiButton;
